'use client'

import { useRouter } from 'next/router'
import { PROD_URL, ROUTES } from '@/constants'
import { Article } from '@/types/Article'
import { Button } from '../../ui/button/buttonWithSpin'
import Hero from '../../ui/hero'
import {
  HeroCallToActionButtonWrapper,
  HeroCard,
  HeroCardHeader,
  HeroCardText,
  HeroImageCamera,
  HeroPhotographerButtonWrapper,
} from './heroLatestArticle.style'

type HeroLatestArticleProps = {
  article: Article
  title?: string
  description?: string
  label?: string
  smallLabel?: string
  url?: string
  showLabel?: boolean
  onImageClickCb?: () => void
  photographer?: {
    name: string
    url: string
  }
  ctaBgColor?: string
  ctaColor?: string
}

const HeroLatestArticle: React.FC<HeroLatestArticleProps> = ({
  article,
  title = 'Your Day, Your Way',
  description = 'Join Rock My Wedding to find inspiration, planning tools, suppliers, and more.',
  label = 'Let’s get planning!',
  showLabel = true,
  smallLabel = 'Latest article',
  url = ROUTES.AUTH.SIGN_IN,
  photographer = null,
  onImageClickCb = () => {},
  ctaColor,
  ctaBgColor,
}) => {
  const router = useRouter()
  const content = (
    <HeroCard>
      <HeroCardHeader>{title}</HeroCardHeader>
      <HeroCardText>{description}</HeroCardText>
      {showLabel && (
        <HeroCallToActionButtonWrapper>
          <Button
            containerStyle={{
              backgroundColor: ctaBgColor || undefined,
              color: ctaColor || undefined,
            }}
            onClick={() => router.push(url)}
            label={label}
          />
        </HeroCallToActionButtonWrapper>
      )}
      {photographer !== null && (
        <HeroPhotographerButtonWrapper>
          <HeroImageCamera
            src={`${PROD_URL}/assets/images/camera.png`}
            alt="Camera"
            width={24}
            height={24}
            fit
          />
          <span>Photography by </span>
          <a target="_blank" rel="noreferrer" href={photographer?.url}>
            {photographer?.name}
          </a>
        </HeroPhotographerButtonWrapper>
      )}
    </HeroCard>
  )

  return (
    <Hero
      imageSrc={article.hero_image_ref?.url}
      imageAlt={article.hero_image_ref?.alt}
      imageChipText={smallLabel}
      onImageClickCb={onImageClickCb}
      content={content}
    />
  )
}

export default HeroLatestArticle
